import React from 'react';
import Addresses from '../../components/mweb/Address/Addresses';
import SecondaryNav from '../../components/mweb/SecondaryNav/SecondaryNav';

const Address = props => {
  return (
    <div className="ac-addresses">
      <SecondaryNav
        source="accounts"
        showCart={false}
        showSearch={false}
        title="Manage Addresses"
        capitalize
      />
      <Addresses source="accounts" />
    </div>
  );
};

export default Address;
